module.exports = __webpack_public_path__ + "2a3b08f24fe5dd3a5ad4a95ba6d49127.jpg";